import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  SaveTemplateRequest,
  TemplateFolder,
  UpdateTemplateRequest,
} from '@ps/survey-utils';

import { SaveTemplatePayloadInput } from '../api/mapper/save-template.payload.mapper';

export const TemplateActions = createActionGroup({
  source: 'Template',
  events: {
    'Load Templates': props<{
      hasImpersonatedBuyer: boolean;
      companyId: number;
    }>(),
    'Load Save Target Folders': props<{
      hasImpersonatedBuyer: boolean;
      companyId: number;
    }>(),
    'Create Template Folder': props<{
      name: string;
      parentFolderId?: number;
    }>(),
    'Save Template': props<{ request: SaveTemplateRequest }>(),
    'Update Template': props<{ request: UpdateTemplateRequest }>(),
    // Carry the already-captured survey. Passing it through the action is what
    // lets the write live here while the form state stays in
    // `@ps/survey-creation-data-access` — importing it back would be a cycle.
    'Save Template Snapshot': props<{ input: SaveTemplatePayloadInput }>(),
    'Update Template Snapshot': props<{
      templateId: number;
      input: SaveTemplatePayloadInput;
    }>(),
    Reset: emptyProps(),
  },
});

export const TemplateApiActions = createActionGroup({
  source: 'Template API',
  events: {
    'Load Templates Success': props<{
      templates: TemplateFolder[];
      cachedAt: number;
    }>(),
    'Load Templates Failure': props<{ error: string }>(),
    'Load Save Target Folders Success': props<{ folders: TemplateFolder[] }>(),
    'Load Save Target Folders Failure': emptyProps(),
    'Create Template Folder Success': props<{ folder: TemplateFolder }>(),
    'Create Template Folder Failure': props<{ error: string }>(),
    'Save Template Success': emptyProps(),
    'Update Template Success': emptyProps(),
  },
});
